import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer mt-auto py-3 bg-dark">
      <div className="container text-center">
        <span>© 2026 Kubo TapTap. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
